import api from '../../../services/api';

/**
 * GET Employee Global Setup settings
 * @return {Promise<any>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getEmployeeGlobalSetup = () => api.get('api/v1/employee/GlobalSetup');
